var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2946",
    "data-name": "Groupe 2946",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.804,
    height: 48.61,
    viewBox: "0 0 40.804 48.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.094,
    y1: 1.679,
    x2: 0.773,
    y2: -0.014,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#fbbf02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.072,
    y1: 1.402,
    x2: 0.751,
    y2: -0.292,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2014",
    "data-name": "Trac\\xE9 2014",
    d: "M-166.825,2740.106a3.659,3.659,0,0,0,3.659-3.659,3.659,3.659,0,0,0-3.659-3.659h-5.963a10.074,10.074,0,0,1-7.875-3.782,10.217,10.217,0,0,1-1.975-8.636,10.381,10.381,0,0,1,10.313-7.791h5.5a3.659,3.659,0,0,0,3.659-3.659,3.658,3.658,0,0,0-3.659-3.659h-5.5c-8.4,0-15.747,5.7-17.462,13.546a17.5,17.5,0,0,0,3.423,14.787,17.357,17.357,0,0,0,13.577,6.513Z",
    transform: "translate(190.206 -2705.26)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2015",
    "data-name": "Trac\\xE9 2015",
    d: "M-138.793,2739.985a17.358,17.358,0,0,0-13.576-6.512h-5.963a3.659,3.659,0,0,0-3.659,3.659,3.659,3.659,0,0,0,3.659,3.659h5.963a10.073,10.073,0,0,1,7.875,3.783,10.218,10.218,0,0,1,1.975,8.636A10.382,10.382,0,0,1-152.832,2761h-5.5a3.659,3.659,0,0,0-3.659,3.659,3.659,3.659,0,0,0,3.659,3.659h5.5c8.4,0,15.746-5.7,17.463-13.546A17.507,17.507,0,0,0-138.793,2739.985Z",
    transform: "translate(175.756 -2719.709)",
    fill: "url(#linear-gradient-2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swapIcon.c1f7ced26af138894928ff814b566de1.svg";
export { ForwardRef as ReactComponent };